import { render, staticRenderFns } from "./DropdownTableHeader.vue?vue&type=template&id=63c38b6d&"
import script from "./DropdownTableHeader.vue?vue&type=script&lang=js&"
export * from "./DropdownTableHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports